<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VDataTableDigests from "@/components/VDataTable/VDataTableDigests.vue";

export default {
    name: "ProjectsDigests" ,
    components: {
        VDataTableDigests,
        AjaxLoad,
    },
    props: {
        idProject: {
            type: String,
        },
    },
    methods: {
        doShowDigestPage(id) {
            this.$router.push({name: 'ForumEventDigestsItem', params: {ID_DIGESTS: id}});
        },
        onDblClickRow(e, {item}) {
            this.doShowDigestPage(item.id);
        },
        onClickAdd() {
            this.doShowDigestPage(0);
        },
    }
}
</script>

<template>
    <ajax-load
        ref="ajax"
        :active="!!idProject"
        :url="$apiUrl.getProjectDigestsUrl({id_project: idProject})"
        :transform="response => response.data"
        v-slot="{data, resolved, active}"
    >
        <v-card>
            <v-data-table-digests
                :loading="!resolved && !!active"
                :items="data?.data"
                :footer-props="{itemsPerPageOptions:[20]}"
                :custom-permissions="data?.meta?.permissions || {}"
                @dblclick:row="onDblClickRow"
                @click:add="onClickAdd"
                @click:reload="() => $refs.ajax.load()"
                heading="Дайджесты"
                search=""
                filter
                with-toolbar
            ></v-data-table-digests>
        </v-card>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>